<template>
  <div>
            <multiselect
                     v-model="val"
                      tag-placeholder="Нажмите Enter, чтобы вставить..."
                      selectedLabel="Применен"
                      placeholder="Введите новый тег..."
                      deselectLabel="Нажмите, чтобы удалить"
                      :showLabels="false"
                      label="title"
                      :loading="loading"
                      track-by="title"
                      :options="list"
                      :taggable="true"
                      :searchable="true"
                      :multiple="true"
                      @tag="add"
                      @input="input"
                    @search-change="search"
              ></multiselect>
              <br/>
              <br/>
  </div>
</template>
<script>

export default {
  name: "Tags",
  props: {
    value: {
      default: function(){
        return [];
      },
    }
  },
  data() {
    return {
        loading : false,
        val : [],
        list:[]
    };
  },
  created() {
      this.val = this.value;
  },
  methods: {
    add(val){
      this.val.push({id:null, title:val});
    },
    input(){
        this.$emit('input', this.val);
    },
    search(query){
      this.loading = true;
      this.$http
        .get("warehouse/values", {
          params: {
           search : query,
          },
        })
        .then((response) => {
          this.list = response.data.data;
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 400);
        });
    }
  },
  computed: {

  },
};
</script>

